import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import _ from 'lodash';
import Helmet from 'react-helmet';
import windowSize from 'react-window-size';
import moment from 'moment';
import Parser from 'html-react-parser';
import { hotjar } from 'react-hotjar';

import rules from '../../util/pageRules';
import urlHelper from '../../util/url';
import config from '../../config';
import { clean } from './ErrorsActions';
import Loading from '../../components/Loading/Loading';
import Navigation from './components/Navigation/Navigation';
import FilterPlaceholder from '../../components/Filter/FilterPlaceholder';
import Searchie from '../../components/Searchie/Searchie';
import IntercomMessenger from '../../components/Chat/Intercom';
import { hide } from '@intercom/messenger-js-sdk';
import DashboardSelector from '../../components/DashboardSelector/DashboardSelector';

import { setOutside, loadData, setApp, setWallmode, toggleNavigationShown, initSocket } from './AppActions';
import { resetFiltersHash } from '../../components/Filter/FilterActions';

import book from '../../assets/img/headset-mic-icon.svg';
import messages from '../../assets/img/group-icon.svg';
import pets from '../../assets/img/pets-icon.svg';

// Import Style
import '../../assets/styles/styles.scss';
import './App.scss';

export class App extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isVisibleChatIntercom: false,
      isVisibleSearchie: false,
      isVisibleFab: true
    };
  }

  componentDidMount() {
    const isWallboard = rules.isWallboard(this.props.location.pathname)

    this.props.router.listen(() => {
      this.props.hideNav();
    });

    if (this.props.location.query.app) {
      this.props.setOutside({
        app: this.props.location.query.app,
        boardId: this.props.location.query.boardId,
        aid: this.props.location.query.aid,
        name: this.props.location.query.name,
        dashboardId: this.props.location.query.dashboardId,
        akbBoardId: this.props.location.query.akbBoardId,
        host: this.props.location.query.host,
        noBoard: !this.props.location.query.boardId && this.props.location.query.aid && this.props.location.query.dashboardId && this.props.location.query.akbBoardId,
        noProject: !this.props.location.query.projectId,
        projectId: this.props.location.query.projectId,
      });
    }

    const urlParts = urlHelper.split();
    if (urlParts.subdomain) {
      this.props.setApp(urlParts.subdomain);
    } else {
      this.props.setApp('trello');
    }

    if (isWallboard) {
      this.props.setWallmode();
    }
    if (
      this.props.location.pathname === '/login' ||
      this.props.location.pathname === '/terms' ||
      this.props.location.pathname === '/welcome'
    ) {
      this.initHotJar();
    }    
  }

  componentDidUpdate(prevProps) {
    const isWallboard = rules.isWallboard(this.props.location.pathname)

    if (this.props.error && prevProps.error != this.props.error) {
      let msg = '';
      try {
        msg = Parser(this.props.error.message || this.props.error);
      } catch (e) {
        msg = this.props.error.message || this.props.error;
      }

      toast.error(<div>{msg}</div>, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        className: 'error_bar',
        ...this.props.msgOpts
      });
      this.props.clean();
    }

    if (this.props.success && prevProps.success != this.props.success) {
      toast.success(this.props.success.message || this.props.success, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        className: 'success_bar',
        ...this.props.msgOpts
      });
      this.props.clean();
    }

    if (prevProps.user._id !== this.props.user._id) {
      if (!isWallboard) {
        this.identifyHotJar();
      }
    }

    let prevDashboard = prevProps.selected || {};
    if (
      this.props.selected &&
      this.props.selected._id &&
      !_.isEqual(prevDashboard, this.props.selected) &&
      this.dataShouldUpdate(prevDashboard, this.props.selected)
    ) {
      this.props.resetFiltersHash();
      this.props.loadData(this.props.selected._id, this.getDates(), this.props.user.config.disableCfActivities);
      this.props.initSocket(this.props.selected.boardId);
    }

    if (
      this.props.filtersUpdated &&
      (+prevProps.dates.startDate != +this.props.dates.startDate ||
        +prevProps.dates.endDate != +this.props.dates.endDate)
    ) {
      this.props.loadData(this.props.selected._id, this.props.dates, this.props.user.config.disableCfActivities);
    }

    if (this.props.windowWidth <= 992) {
      if (rules.noLinks(this.props.location.pathname)) {
        document.body.classList.add('mobile');
      } else {
        document.body.classList.remove('mobile');
      }
    } else {
      document.body.classList.remove('mobile');
    }
    const prevLoc = prevProps.location.pathname;
    const newLoc = this.props.location.pathname;

    if (!isWallboard && prevLoc !== newLoc) {
      hide();
    }
  }

  identifyHotJar() {
    if (this.props.user._id && this.props.user.status === 'trial' && !!config.hotjarKey) {
      if (hotjar.initialized()) {
        hotjar.identify(this.props.user._id, { email: this.props.user.email });
      } else {
        this.initHotJar();
        setTimeout(() => {
          if (hotjar.initialized()) {
            hotjar.identify(this.props.user._id, { email: this.props.user.email });
          }
        }, 1000);
      }
    }
  }

  ChatHandleClick = () => {
    this.setState({
      isVisibleChatIntercom: true,
      isVisibleFab: false
    });    
  };

  hideChat = () => {
    this.setState({
      isVisibleChatIntercom: false,
      isVisibleFab: true
    });   
  } 

  SearchieHandleClick = () => {
    this.setState({
      isVisibleSearchie: true,
      isVisibleFab: false,
      isVisibleChatIntercom: false,
    });
  };

  SearchieHandleClickClose = () => {
    this.setState({
      isVisibleSearchie: false,
      isVisibleFab: true,
      isVisibleChatIntercom: false,
    });
  };

  initHotJar() {
    !!config.hotjarKey && !hotjar.initialized() && hotjar.initialize(config.hotjarKey, 6);
  }

  getDates() {
    const model = this.props.selected.globalConfig;

    let from, to;
    if (model && (model.dateDiff || model.customDate)) {
      if (model.customDate) {
        from = moment(model.from).startOf('day');
        to = moment(model.to).endOf('day');
      } else {
        to = moment().endOf('day');
        if (model.fixedStartDate) {
          from = moment(model.from).startOf('day');
        } else {
          from = moment()
            .subtract(model.dateDiff, 'day')
            .startOf('day');
        }
      }
    } else {
      from = this.props.dates.startDate;
      to = this.props.dates.endDate;
    }

    return {
      startDate: from,
      endDate: to
    };
  }

  dataShouldUpdate(prev, next) {
    if (!prev._id) return true;

    return (
      prev._id != next._id ||
      !_.isEqual(prev.todo, next.todo) ||
      !_.isEqual(prev.wip, next.wip) ||
      !_.isEqual(prev.done, next.done) ||
      prev.lastUpdated != next.lastUpdated
    );
  }

  render() {
    const path = this.props.location.pathname;
    const parts = path.split('/');
    let pageClass = parts[1] + (parts[3] ? parts[3] : '');
    if (parts[1] == 'forecasting') {
      pageClass = parts[1];
    }
    if (/^\d+$/.test(pageClass)) {
      pageClass = 'error' + pageClass;
    }
    if (pageClass) {
      pageClass = pageClass.replace('-', '');
    }
    if (pageClass === 'report' && this.props.wallmode) {
      pageClass = 'report-wallboard';
    }  
     if (pageClass === 'portfolios' && this.props.wallmode) {
      pageClass = 'portfolios-wallboard';
    }    
    const isChartPage = rules.isChartPage(path);
    const noLinks = rules.noLinks(path);
    const noHeader = rules.noHeader(path);
    const noFilter = rules.noFilter(path);
    const isChatPage = path.indexOf('/chat') > -1;

    const isWallboard = rules.isWallboard(this.props.location.pathname)
    const isLogin = rules.isLogin(this.props.location.pathname)
    const isIntercomEnabled = 
      this.props.user._id && this.props.user._id !== 'temp' &&
      !this.props.user.chatOff && !isWallboard && !this.props.location.query.app;

    const isActiveUser =
      (this.props.user.status === 'trial' && !this.props.user.expired) || this.props.user.status === 'active';
    const isVisibleAndSearchie =
      this.state.isVisibleSearchie &&
      this.props.user._id &&
      this.props.user._id !== 'temp' &&
      !this.props.user.chatOff &&
      isActiveUser &&
      !this.props.wallmode;
    const chatVisible = !isLogin && !isWallboard;  
    const renderChartPages = () => {
      return (
        <div>
          {!this.props.wallmode && !noFilter && <FilterPlaceholder />}
          {!this.props.user.expired && this.props.user.loaded && <DashboardSelector></DashboardSelector>}
          {!this.props.user.expired &&
          !this.props.wallmode &&
          (this.props.dataLoading || !this.props.data.activities) ? (
            <div className='table-loading'><Loading /></div>
          ) : (
            <div>{this.props.children}</div>
          )}
        </div>
      );
    };

    return (
      <div>
        <Helmet
          title=""
          titleTemplate="%s | Nave"
          meta={[
            { charset: 'utf-8' },
            {
              'http-equiv': 'X-UA-Compatible',
              content: 'IE=edge'
            },
            {
              name: 'viewport',
              content: 'width=device-width, initial-scale=1'
            }
          ]}
        />
        <ToastContainer autoClose={6000} newestOnTop={true} />

        {!noHeader && this.props.user._id ? (
          <div className='wrap_box'>
            <div className={`main ${pageClass} ${this.props.dataLoading ? "loading" : ""} ${this.props.wallmode ? "wallboard" : ""}`}>
              {!this.props.wallmode && <Navigation showLinks={!noLinks} />}
              <div className='content_col'>{isChartPage ? renderChartPages() : this.props.children}</div>
            </div>
          </div>
        ) : (
          <div>{this.props.children}</div>
        )}

        { chatVisible && this.state.isVisibleChatIntercom && (
          <div className="fab-opened">             
            <button className="fab-button"  onClick={this.hideChat}>
              <i className="fab-button-icon-close"></i>
            </button>
          </div>
        )}       
          
        { chatVisible && this.state.isVisibleFab && (
          <div className="fab-container">
            <button className="fab-button">
              <i className="fab-button-icon"></i>
            </button>
            <div className="fab-list">
              <a href="https://doodle.com/bp/sonyasiderova/customer-success" target="_blank" className="fab-item">
                <img src={book} alt="#" />
                Book a call
              </a>
              <button className="fab-item" onClick={this.ChatHandleClick}>
                <img src={messages} alt="#" />
                Chat with us
              </button>
              <button className="fab-item" onClick={this.SearchieHandleClick}>
                <img src={pets} alt="#" />
                Ask our AI assistant
              </button>
            </div>
          </div>
        )}

        { chatVisible && (
          <Searchie visible={isVisibleAndSearchie} onHide={this.SearchieHandleClickClose}></Searchie>
        )}

        { chatVisible && isIntercomEnabled && (          
          <IntercomMessenger appId={config.intercomKey} opened={this.state.isVisibleChatIntercom} user={this.props.user} onStateUpdate={(state) => this.setState(state)} />
        )}
        
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    clean: () => dispatch(clean()),
    setOutside: context => dispatch(setOutside(context)),
    setApp: app => dispatch(setApp(app)),
    setWallmode: () => dispatch(setWallmode()),
    loadData: (id, dates, disableCfActivities) => dispatch(loadData(id, dates, disableCfActivities)),
    hideNav: () => dispatch(toggleNavigationShown(false)),
    initSocket: dashboardId => dispatch(initSocket(dashboardId)),
    resetFiltersHash: () => dispatch(resetFiltersHash())
  };
};

function mapStateToProps(state) {
  return {
    intl: state.intl,
    user: state.auth.user,
    authenticated: state.auth.authenticated,
    app: state.app.app,
    outside: state.app.outside,
    dataLoading: state.app.isLoading,
    data: state.app.data,
    wallmode: state.app.wallmode,
    dashboards: state.dashboards.list,
    selected: state.dashboards.selected,
    error: state.errors.error,
    success: state.errors.success,
    msgOpts: state.errors.opt,
    dates: state.filters.dates,
    filtersUpdated: state.filters.updated
  };
}

export default withRouter(windowSize(connect(mapStateToProps, mapDispatchToProps)(App)));
